<div class="container mx-auto mb-24 mt-12 w-[80%]">
  <h1 class="mb-6 text-center text-3xl font-semibold text-dark-blue">Tablas Maestras</h1>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
    <div *ngFor="let maestro of maestros">
      <div
        class="flex h-full flex-col rounded-lg border border-dark-blue shadow-lg transition-all duration-300 ease-in-out"
      >
        <div class="p-4">
          <h2 class="text-center text-xl font-bold text-dark-blue">{{ maestro.nombre }}</h2>
          <p class="text-gray-700 mt-2 text-center">Gestión de {{ maestro.nombre.toLowerCase() }}</p>
        </div>
        <div class="mt-auto p-4">
          <a
            [routerLink]="maestro.ruta"
            class="hover:medium-green mx-auto block w-4/6 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-center text-seasalt transition delay-100 ease-in hover:bg-seasalt hover:text-dark-blue"
          >
            Ir a {{ maestro.nombre }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
